import ApiService from '@/services/api.service'

const VictimService = {

	/**
	 * Recherche les victimes des derniers bilans reçus
	 */
	getLastReceived: async function() {
		const response = await ApiService.get('/api/victims/lasts')
		return response.data
	},

	/**
	 * Recherche les victimes
	 */
	getVictims: async function(dateRange, showClosed, isDae, onlyWithoutDestCRA) {
		var url = '/api/victims?'
		if (dateRange && dateRange.length === 2 && dateRange[0] && dateRange[1]) {
			url += 'start='+ dateRange[0] + '&end=' + dateRange[1] + '&'
		}
		url += 'withClosedSate=' + !!showClosed + '&isDae=' + isDae + '&onlyWithoutDestCRA=' + !!onlyWithoutDestCRA

		const response = await ApiService.get(url)
		return response.data
	},

	/**
	 * Comptes les victimes
	 */
	countVictims: async function() {
		const response = await ApiService.get('/api/victims/count')
		return response.data
	},

	/**
	 * Mise à jour de l'observationCRA
	 */
	updateObs: async function(id, obs) {
		const data = {'observationCRA' : obs ? obs : null}
		const response = await ApiService.post('/api/victims/'+ id, data)
		return response.data
	},

	/**
	 * Mise à jour de la destinationCRA
	 */
	updateDest: async function(id, destId) {
		var data = {}
		if (destId === 'NO_TRANSP') {
			data.transportCRA = false
		} else if (typeof destId === 'string' && destId.charAt(0) === 't') {
			data.tmpUserId = parseInt(destId.substring(1))
		} else {
			data.entityId = parseInt(destId)
		}
		const response = await ApiService.post('/api/victims/'+ id, data)
		return response.data
	},

	/**
	 * Mise à jour de la du code dae => T pour traité
	 */
	updateDae: async function(id) {
		const data = {'dae' : 'T'}
		const response = await ApiService.post('/api/victims/'+ id, data)
		return response.data
	}
}

export default VictimService